export enum ModalIntentType {
    WARNING = "warning",
    DANGER = "danger"
}
